module.exports = __webpack_public_path__ + "img/modal_x.1aaf8c72.svg";